import React from 'react'

import {SkeletonLoader} from '@daedalus/atlas/SkeletonLoader'

import {OfferWrapper} from './styles'

export const Skeleton = () => {
  return (
    <OfferWrapper
      container
      wrap="nowrap"
      alignItems="center"
      justify="space-between"
      spacing="s000"
    >
      <div>
        <SkeletonLoader width={120} height={20} />
      </div>
      <SkeletonLoader width={45} height={20} marginTop={0} />
    </OfferWrapper>
  )
}
